/* PDP Kumo Lounger (20.10.2026): probki kolorow (klik podmienia pierwsze zdjecie galerii; obraz koloru ladowany dopiero po kliknieciu) i licznik galerii na telefonie. Bez zaleznosci. */
(function () {
  var root = document.getElementById('swp-klr');
  if (!root) return;
  var name = root.querySelector('[data-k-cname]');
  var img = root.querySelector('[data-k-main]'), first = root.querySelector('[data-k-first]');
  var orig = img ? {src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '', alt: img.alt} : null;
  var sw = [].slice.call(root.querySelectorAll('.k-swb'));
  var buy = root.querySelector('[data-k-buy]'), nId = root.querySelector('[data-k-native-id]'), nAdd = root.querySelector('[data-k-native-add]'), msg = root.querySelector('[data-k-msg]');
  function setBuy(b) {
    if (!buy || !nId) return;
    var vid = b.getAttribute('data-vid');
    if (vid) nId.value = vid;
    buy.disabled = !vid || b.getAttribute('data-av') !== 'true';
  }
  if (buy && nAdd) buy.addEventListener('click', function () {
    if (buy.disabled) return;
    if (msg) msg.textContent = '';
    try { nAdd.click(); } catch (e) { if (msg) msg.textContent = buy.getAttribute('data-fail') || ''; }
  });
  function pick(b) {
    setBuy(b);
    sw.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
    if (name) name.textContent = b.getAttribute('data-name');
    if (!img) return;
    if (b.hasAttribute('data-real')) {
      img.srcset = orig.srcset; img.src = orig.src; img.alt = orig.alt; first.classList.remove('is-pack');
    } else if (b.getAttribute('data-src')) {
      img.srcset = b.getAttribute('data-srcset') || ''; img.src = b.getAttribute('data-src'); img.alt = b.getAttribute('data-alt') || ''; first.classList.add('is-pack');
    } else return;
    var tr = root.querySelector('[data-k-slides]');
    if (tr && tr.scrollLeft > 0) tr.scrollTo({left: 0, behavior: 'smooth'});
    var r = first.getBoundingClientRect(), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
    if (vis < r.height * 0.35) window.scrollBy({top: r.top - 70, behavior: 'smooth'});   /* telefon: zdjecie nad probkami bylo poza ekranem (Joanna 20.10: „nie dziala przelaczanie”) */
  }
  sw.forEach(function (b, i) {
    b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
    b.addEventListener('click', function () { pick(b); });
    b.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = sw[(i + d + sw.length) % sw.length]; pick(n); n.focus();
    });
  });
  var track = root.querySelector('[data-k-slides]'), num = root.querySelector('[data-k-n]');
  if (track && num) {
    var t = 0;
    track.addEventListener('scroll', function () {
      if (t) return;
      t = requestAnimationFrame(function () {
        t = 0;
        var w = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 1;
        num.textContent = Math.min(track.children.length, Math.round(track.scrollLeft / w) + 1);
      });
    }, {passive: true});
  }
})();

/* Formularz zapisu Kumo Lounger (z wersji coming soon, 20.10.2026): zapis na liste Klaviyo przez Client Subscriptions API (klucz publiczny, bez nowego skryptu zewnetrznego).
   Ladowany z defer przez sections/swp-lounger-soon.liquid. Konfiguracja w atrybutach formularza [data-ls-form]:
   data-company (klucz publiczny), data-list (id listy), data-rev (revision API), data-source (custom_source), data-props (JSON wlasciwosci profilu: jezyk, rynek).
   Po 202: formularz znika, pokazuje sie stan „jestes na liscie” (lista z pojedyncza zgoda, Wtmm5Q). Pole-pulapka dla botow: wypelnione = udajemy sukces, nic nie wysylamy. */
(function () {
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function init(form) {
    if (form.getAttribute('data-ls-ready')) return;
    form.setAttribute('data-ls-ready', '1');
    var box = form.closest('[data-ls-box]');
    var ok = box && box.querySelector('[data-ls-ok]');
    var inp = form.querySelector('input[type="email"]');
    var hp = form.querySelector('[data-ls-hp]');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-ls-msg]');
    var label = btn.textContent;
    var props = {};
    try { props = JSON.parse(form.getAttribute('data-props') || '{}'); } catch (e) {}
    function err(t) { msg.textContent = t; inp.setAttribute('aria-invalid', 'true'); }
    function done() {
      form.hidden = true;
      if (ok) { ok.hidden = false; ok.focus(); }
    }
    inp.addEventListener('input', function () { if (msg.textContent) { msg.textContent = ''; inp.removeAttribute('aria-invalid'); } });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = (inp.value || '').trim();
      if (!RE.test(email)) { err(form.getAttribute('data-err-email')); inp.focus(); return; }
      if (hp && hp.value) { done(); return; }
      if (!/^[A-Za-z0-9]{6}$/.test(form.getAttribute('data-list') || '')) { err(form.getAttribute('data-err-gen')); return; }   // lista jeszcze nie podpieta (znacznik LISTA_KUMO_LOUNGER): nic nie wysylamy
      btn.disabled = true; btn.textContent = form.getAttribute('data-sending'); msg.textContent = '';
      var attrs = { email: email };
      if (Object.keys(props).length) attrs.properties = props;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': form.getAttribute('data-rev') },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: form.getAttribute('data-source'),
          profile: { data: { type: 'profile', attributes: attrs } }
        }, relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } } } })
      }).then(function (r) {
        if (!(r.ok || r.status === 202)) throw new Error(r.status);
        done();
      }).catch(function () {
        btn.disabled = false; btn.textContent = label; err(form.getAttribute('data-err-gen'));
      });
    });
  }
  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-ls-form]'), init); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
})();

/* 21.10.2026: strzalki galerii na telefonie i data dostawy (jak snippets/shb-zaufanie: dni robocze z data-days, tekst z data-t z %date%) */
(function () {
  var root = document.getElementById('swp-klr');
  if (!root) return;
  var tr = root.querySelector('[data-k-slides]'), pv = root.querySelector('[data-k-prev]'), nx = root.querySelector('[data-k-next]');
  if (tr && pv && nx) {
    var w = function () { return tr.firstElementChild ? tr.firstElementChild.getBoundingClientRect().width : tr.clientWidth; };
    var st = function () { pv.disabled = tr.scrollLeft < 8; nx.disabled = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 8; };
    pv.addEventListener('click', function () { tr.scrollBy({left: -w(), behavior: 'smooth'}); });
    nx.addEventListener('click', function () { tr.scrollBy({left: w(), behavior: 'smooth'}); });
    tr.addEventListener('scroll', st, {passive: true}); st();
  }
  var e = root.querySelector('[data-k-dl]');
  if (e && window.Intl) {
    var n = +e.getAttribute('data-days'), d = new Date(), a = 0;
    d.setHours(12);
    while (a < n) { d.setDate(d.getDate() + 1); var x = d.getDay(); if (x !== 0 && x !== 6) a++; }
    try {
      var t = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {weekday: 'short', day: 'numeric', month: 'long'}).format(d);
      e.querySelector('[data-k-dlt]').innerHTML = e.getAttribute('data-t').replace('%date%', '<b>' + t + '</b>');
      e.hidden = false;
    } catch (z) {}
  }
})();
